"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientImage = void 0;
const core_1 = require("@material-ui/core");
const asset_list_overview_1 = require("client/components/asset-list-overview");
require("client/modules/dashboard/modules/widget-grid/components/provider-widget/provider-widget.less");
const iframe_preview_1 = require("client/modules/inventory-order/tabs/order-review/components/iframe-preview");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const ReactTooltip = require("react-tooltip");
const capitalize_string_1 = require("shared/util/capitalize-string");
require("./patient-image.less");
const moment = require("moment");
let PatientImage = class PatientImage extends React.Component {
    constructor() {
        super(...arguments);
        this.iframeUrl = "";
        this.handleError = (event) => {
            event.target.src = "/assets/users.png";
        };
        this.renderPatientAssetListRow = () => this.props.upload && this.props.upload.length
            ? this.props.upload
                .sort((a, b) => moment(a.expDate) < moment(b.expDate) ? 1 : -1)
                .map((upload, index) => {
                let expdate = "";
                if (upload.expDate) {
                    expdate = moment(upload.expDate).format("MM/DD/YYYY");
                }
                return (React.createElement("li", { "data-tip": `${upload.fileOriginalName} ${upload.description ? " (" + upload.description + ")" : ""}
                `, onClick: this.handleAssetPreviewClick(upload), key: index, className: "list" },
                    React.createElement("div", { className: "list-expdate__name" }, upload.description || upload.fileOriginalName),
                    React.createElement("div", { className: "list-expdate__date" }, expdate ? ` ${expdate}` : "")));
            })
            : null;
        this.handleAssetPreviewClick = (upload) => () => {
            this.iframeUrl = upload.filePath;
            this.currentAssetViewing = upload;
        };
        this.handlePreviewClose = () => {
            this.iframeUrl = "";
            this.currentAssetViewing = null;
        };
    }
    render() {
        const { prefix, firstName, middleName, lastName, suffix } = this.props.patientData;
        const { upload } = this.props;
        let srcUrl;
        if (upload && upload.length) {
            const userAvatar = upload.find(u => u.informationType === "patientImage");
            if (userAvatar) {
                srcUrl = userAvatar.filePath;
            }
        }
        const patientFullName = `${prefix || ""} ${firstName || ""} ${middleName ||
            ""} ${lastName || ""} ${suffix || ""}`;
        return (React.createElement("div", { className: "provider-widget__avatar", style: { margin: "10px auto", minHeight: "200px" } },
            React.createElement("img", { className: "patient-image", src: srcUrl || "/assets/users.png", onError: this.handleError }),
            React.createElement(core_1.Typography, { align: "center" }, capitalize_string_1.capitalizeString(patientFullName)),
            React.createElement("div", { className: "view-assets" },
                React.createElement(asset_list_overview_1.AssetListOverview, { btnLabel: "Edit Asset", onClick: this.props.viewPatientAssets }, this.renderPatientAssetListRow())),
            this.iframeUrl ? (React.createElement(iframe_preview_1.IFramePreview, { title: this.currentAssetViewing.fileOriginalName || "N/A", iframeUrl: this.iframeUrl, download: this.iframeUrl, onClose: this.handlePreviewClose })) : null,
            React.createElement(ReactTooltip, { effect: "solid", place: "left", delayShow: 300, "data-type": "info", multiline: true })));
    }
};
__decorate([
    mobx_1.observable
], PatientImage.prototype, "iframeUrl", void 0);
__decorate([
    mobx_1.observable
], PatientImage.prototype, "currentAssetViewing", void 0);
PatientImage = __decorate([
    mobx_react_1.observer
], PatientImage);
exports.PatientImage = PatientImage;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-detail/components/edit-patient/components/patient-image/patient-image.tsx
// module id = 3775
// module chunks = 0